<div>
  <label *ngIf="label" [attr.for]="identifier">{{label}}
    <pmv-mini-loading [isLoading]="isLoading"></pmv-mini-loading>
  </label>
  <input #inputtext [(ngModel)]="value" [type]="type" [id]="identifier" [placeholder]="placeholder || ''" [ngClass]="{'form-control': true, invalid: (invalid | async)}"
    [disabled]="disabled" [readonly]="readonly" (blur)="blurEvent()" [autocomplete]="autocomplete" [maxlength]="maxlength"
  />
  <validation [elementBase]="this"></validation>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.InputTextComponent.html